import React, { useState } from "react";
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition,
} from "@headlessui/react";
import {
  EllipsisHorizontalIcon,
  VideoCameraIcon,
  LinkIcon,
  PencilIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import { Fragment } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { toast } from "sonner";

export function MeetActions({
  meeting,
  onJoinMeeting,
  onEditMeeting,
  onCancelMeeting,
  disabled = false,
}) {
  const handleJoin = (e) => {
    e.stopPropagation();
    onJoinMeeting(meeting.meetLink);
  };

  const handleCopyLink = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(meeting.meetLink);
    toast.success('Meeting link copied to clipboard!');
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    onEditMeeting(meeting);
  };

  const handleCancel = (e) => {
    e.stopPropagation();
    onCancelMeeting(meeting);
  };

  const renderMenuItems = () => (
    <>
      <MenuItem>
        {({ focus }) => (
          <button
            onClick={handleJoin}
            className={clsx(
              "flex h-9 w-full items-center cursor-pointer space-x-3 px-3 tracking-wide outline-hidden transition-colors",
              focus &&
                "dark:bg-dark-600 dark:text-dark-100 bg-gray-100 text-gray-800",
            )}
          >
            <VideoCameraIcon className="size-3.5 stroke-1" />
            <span className="truncate">Join Meeting</span>
          </button>
        )}
      </MenuItem>
      <MenuItem>
        {({ focus }) => (
          <button
            onClick={handleCopyLink}
            className={clsx(
              "flex h-9 w-full items-center cursor-pointer space-x-3 px-3 tracking-wide outline-hidden transition-colors",
              focus &&
                "dark:bg-dark-600 dark:text-dark-100 bg-gray-100 text-gray-800",
            )}
          >
            <LinkIcon className="size-3.5 stroke-1" />
            <span className="truncate">Copy Link</span>
          </button>
        )}
      </MenuItem>
        {!disabled && (
          <MenuItem>
            {({ focus }) => (
              <button
                onClick={handleEdit}
                className={clsx(
                  "flex h-9 w-full items-center cursor-pointer space-x-3 px-3 tracking-wide outline-hidden transition-colors",
                  focus &&
                    "dark:bg-dark-600 dark:text-dark-100 bg-gray-100 text-gray-800",
                )}
              >
                <PencilIcon className="size-3.5 stroke-1" />
                <span className="truncate">Edit</span>
              </button>
            )}
          </MenuItem>
        )}
        {!disabled && (
          <MenuItem>
            {({ focus }) => (
              <button
                onClick={handleCancel}
                className={clsx(
                  "flex h-9 w-full items-center cursor-pointer space-x-3 px-3 tracking-wide text-red-600 outline-hidden transition-colors dark:text-red-400",
                  focus && "bg-red-50 dark:bg-red-900/10",
                )}
              >
                <TrashIcon className="size-3.5 stroke-1" />
                <span className="truncate">Cancel</span>
              </button>
            )}
          </MenuItem>
        )}
      
    </>
  );

  return (
    <>
        {meeting.status === 'scheduled' && (
<div className="flex justify-center">
      <Menu as="div" className="relative inline-block text-left">
        <MenuButton
          as="div"
          className="dark:text-dark-200 dark:hover:bg-dark-300/10 dark:focus:bg-dark-300/10 dark:active:bg-dark-300/20 inline-flex size-6 cursor-pointer items-center justify-center rounded-full text-gray-700 hover:bg-gray-300/20 focus:bg-gray-300/20 active:bg-gray-300/25 sm:size-7"
          onClick={(e) => e.stopPropagation()}
        >
          <EllipsisHorizontalIcon className="size-4" />
        </MenuButton>
        <Transition
          as={Fragment}
          enter="transition ease-out"
          enterFrom="opacity-0 translate-y-2"
          enterTo="opacity-100 translate-y-0"
          leave="transition ease-in"
          leaveFrom="opacity-100 translate-y-0"
          leaveTo="opacity-0 translate-y-2"
        >
          <MenuItems
            modal={false}
            className="dark:bg-dark-750 dark:border-dark-500 absolute right-0 bottom-full z-50 mt-2 min-w-[10rem] rounded-lg border border-gray-300 bg-white py-1 shadow-lg shadow-gray-200/50 outline-hidden focus-visible:outline-hidden dark:shadow-none"
          >
            {renderMenuItems()}
          </MenuItems>
        </Transition>
      </Menu>
    </div>
)}</>)}


MeetActions.propTypes = {
  meeting: PropTypes.object.isRequired,
  onJoinMeeting: PropTypes.func.isRequired,
  onEditMeeting: PropTypes.func.isRequired,
  onCancelMeeting: PropTypes.func.isRequired,
};

export default MeetActions;
